// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const bis: CountryValidator<"BE"> = createValidator(
  "be.bis",
  18,
);

export default bis;
export const compact = bis.compact;
export const format = bis.format;
export const validate = bis.validate;
export const generate = (): string =>
  bis.generate?.() ??
  (() => {
    throw new Error(
      "Validator be.bis cannot generate values",
    );
  })();
